import request from "@/utils/request";
import "lodash";
import logger from "@/utils/logger";
const config = require("@/../config/config.json");

export async function svc_publishCategory(payload) {
    logger(`@services/category - svc_publishCategory`, 5);
	return request(`${config.apiUrl}categories_custom/publish?category=${payload.categoryId}`, {
		method: "PUT",
		data: payload
	});
}

export async function svc_reorderCategories(payload) {
    logger(`@services/category - svc_reorderCategories`, 5);
	return request(`${config.apiUrl}categories_custom/reorder`, {
        method: "POST",
        data: payload
	});
}

export async function svc_cloneCategory(payload) {
    logger(`@services/category - svc_cloneCategory`, 5);
	return request(`${config.apiUrl}categories_custom/${payload.categoryId}/clone?toBrand=${payload.toBrand}&toOutlet=${payload.toOutlet}&visibilityLevel=${payload.toTerminalNo}`, {
		method: "POST"
	});
}